const ticket = [
	{
		// 工单列表
		path: '/ticket',
		name: 'ticket',
		component: resolve => require(['@/views/ticket/index'], resolve),
		meta: {
			isHide: true,
			isPermission: true
		}
	},
	{
		// 我的投资
		path: '/ticketDetail',
		name: 'ticketDetail',
		component: resolve => require(['@/views/ticket/detail'], resolve),
		meta: {
			isHide: true
		}
	}
]

export default ticket
